<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportStockCards"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterParts" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part " id="filter-" size="sm" :model.sync="filter.filterPart" :selected="filterRef.filterPart" @input="getFilterParts" @focus="getFilterParts" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart"/>
						<app-input-combobox-autocomplete :options="filterRacks" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Rack " id="filter-" size="sm" :model.sync="filter.filterRack" :selected="filterRef.filterRack" @input="getFilterRacks" @focus="getFilterRacks" :isSelectMethodExists="true" @onSelectMethod="setSelectedRack"/>
						<app-input-combobox-autocomplete :options="filterAreas" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area " id="filter-" size="sm" :model.sync="filter.filterArea" :selected="filterRef.filterArea" @input="getFilterAreas" @focus="getFilterAreas" :isSelectMethodExists="true" @onSelectMethod="setSelectedArea"/>
						<app-input-combobox-autocomplete :options="filterControlCards" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card " id="filter-" size="sm" :model.sync="filter.filterControlCard" :selected="filterRef.filterControlCard" @input="getFilterControlCards" @focus="getFilterControlCards" :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard"/>
						<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.filterCustomer" :selected="filterRef.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" :isSelectMethodExists="true" @onSelectMethod="setSelectedCustomer"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterUoms" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Uom " id="filter-" size="sm" :model.sync="filter.filterUom" :selected="filterRef.filterUom" @input="getFilterUoms" @focus="getFilterUoms" :isSelectMethodExists="true" @onSelectMethod="setSelectedUom"/>
						<app-input-combobox-autocomplete :options="filterQcStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Qc Status " id="filter-" size="sm" :model.sync="filter.filterQcStatus" :selected="filterRef.filterQcStatus" @input="getFilterQcStatuss" @focus="getFilterQcStatuss" :isSelectMethodExists="true" @onSelectMethod="setSelectedQcStatus"/>
						<app-input-datepicker-range  id="fieldset-filter-transaction-date" label-cols-sm="4" label-cols-lg="3" label="Transaction Date " size="sm" :modelFrom.sync="filter.filterTransactionDateFrom" :modelTo.sync="filter.filterTransactionDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportStockCards"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Stock Card</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-reportstockcard" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportStockCards" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>

					<template #table-busy v-if="reportStockCards.length <= 0">
						<app-no-data-image :animate="true" />
					</template>

					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Area" class="table-filter">
							<!-- <b-form-input id="input-area-name-table" @input="getReportStockCardsWithoutLoading" v-model="filter.areaName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportStockCardsWithoutLoading" :options="filterAreas" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area " id="filter-" size="sm" :model.sync="filter.filterArea" @input="getFilterAreas" @focus="getFilterAreas" />
						</b-th>
						<b-th stacked-heading="Rack Number" class="table-filter">
							<!-- <b-form-input id="input-rack-name-table" @input="getReportStockCardsWithoutLoading" v-model="filter.rackName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportStockCardsWithoutLoading" :options="filterRacks" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Rack " id="filter-" size="sm" :model.sync="filter.filterRack" @input="getFilterRacks" @focus="getFilterRacks" />
						</b-th>
						<b-th stacked-heading="Customer" class="table-filter">
							<!-- <b-form-input id="input-customer-name-table" @input="getReportStockCardsWithoutLoading" v-model="filter.customerName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportStockCardsWithoutLoading" :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
						</b-th>
						<b-th></b-th>
						<b-th stacked-heading="Control Card Number" class="table-filter">
							<!-- <b-form-input id="input-control-card-number-table" @input="getReportStockCardsWithoutLoading" v-model="filter.controlCardNumber" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportStockCardsWithoutLoading" :options="filterControlCards" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card " id="filter-" size="sm" :model.sync="filter.filterControlCard" @input="getFilterControlCards" @focus="getFilterControlCards" />
						</b-th>
						<b-th stacked-heading="Part Number" class="table-filter">
							<!-- <b-form-input id="input-part-number-table" @input="getReportStockCardsWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportStockCardsWithoutLoading" :options="filterParts" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part " id="filter-" size="sm" :model.sync="filter.filterPart" @input="getFilterParts" @focus="getFilterParts" />
						</b-th>
						<b-th stacked-heading="Part Name" class="table-filter">
							<!-- <b-form-input id="input-part-name-table" @input="getReportStockCardsWithoutLoading" v-model="filter.partName" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Qty" class="table-filter">
							<!-- <b-form-input id="input-qty-case-table" @input="getReportStockCardsWithoutLoading" v-model="filter.qtyCase" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="UoM" class="table-filter">
							<!-- <b-form-input id="input-uom-name-table" @input="getReportStockCardsWithoutLoading" v-model="filter.uomName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportStockCardsWithoutLoading" :options="filterUoms" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Uom " id="filter-" size="sm" :model.sync="filter.filterUom" @input="getFilterUoms" @focus="getFilterUoms" />
						</b-th>
						<b-th stacked-heading="Transaction Date" class="table-filter">
							<!-- <b-form-input id="input-created-date-table" @input="getReportStockCardsWithoutLoading" v-model="filter.createdDate" size="sm"></b-form-input> -->
							<app-input-datepicker-range @change="getReportStockCardsWithoutLoading"  id="fieldset-filter-transaction-date" label-cols-sm="4" label-cols-lg="3" label="Transaction Date " size="sm" :modelFrom.sync="filter.filterTransactionDateFrom" :modelTo.sync="filter.filterTransactionDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						</b-th>
						<b-th stacked-heading="Status" class="table-filter">
							<!-- <b-form-input id="input-qc-status-name-table" @input="getReportStockCardsWithoutLoading" v-model="filter.qcStatusName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportStockCardsWithoutLoading" :options="filterQcStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Qc Status " id="filter-" size="sm" :model.sync="filter.filterQcStatus" @input="getFilterQcStatuss" @focus="getFilterQcStatuss" />
						</b-th>
					</template>

					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>
					
					<template v-slot:cell(createdDate)="row">
						{{ row.item.createdDate | moment("DD-MMM-YYYY") }}
					</template>

					<template v-slot:cell(qtyCase)="row">
						<div class="input-label-currency">{{ Number(row.item.qtyCase).toLocaleString() }}</div>
					</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-control-card-number" label-cols-lg="12"  label="Control Card Number" label-for="input-control-card-number" size="sm" :model.sync="row.item.controlCardNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-number" label-cols-lg="12"  label="Part Number" label-for="input-part-number" size="sm" :model.sync="row.item.partNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-name" label-cols-lg="12"  label="Part Name" label-for="input-part-name" size="sm" :model.sync="row.item.partName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-case" label-cols-lg="12"  label="Qty" label-for="input-qty-case" size="sm" :model.sync="row.item.qtyCase"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-uom-name" label-cols-lg="12"  label="UoM" label-for="input-uom-name" size="sm" :model.sync="row.item.uomName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-created-date" label-cols-lg="12"  label="Transaction Date" label-for="input-created-date" size="sm" :model.sync="row.item.createdDate"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qc-status-name" label-cols-lg="12"  label="Status" label-for="input-qc-status-name" size="sm" :model.sync="row.item.qcStatusName"   :isEditable="false" :isUpdatable="true" />
						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportStockCardsPaging != null ? reportStockCardsPaging.dataCount : 0)"
											  :per-page="(reportStockCardsPaging != null ? reportStockCardsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportstockcard.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportstockcard.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportStockCard from '@/models/ReportStockCard/ReportStockCard';
import ReportStockCardList from '@/models/ReportStockCard/ReportStockCardList';
import ReportStockCardFilter from '@/filters/ReportStockCard/ReportStockCardFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportStockCard, 
		ReportStockCardList, 
		ReportStockCardFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-number d-stack-none"}},
				{"areaName": {}, "class" : "th-area-name first-child", "label" : "Area", key: 'areaName', }, 
				{"rackName": {}, "class" : "th-rack-name", "label" : "Rack Number", key: 'rackName', }, 
				{"customerName": {}, "class" : "th-customer-name", "label" : "Customer", key: 'customerName', }, 
				{"partClassificationCode": {}, "class" : "th-part-classification-code last-child", "label" : "Part Classification Code", key: 'partClassificationCode', }, 
				{"controlCardNumber": {}, "class" : "th-control-card-number last-child", "label" : "Control Card Number", key: 'controlCardNumber', }, 
				{"partNumber": {}, "class" : "th-part-number d-stack-none", "label" : "Part Number", key: 'partNumber', }, 
				{"partName": {}, "class" : "th-part-name d-stack-none", "label" : "Part Name", key: 'partName', }, 
				{"qtyCase": {}, "class" : "th-qty-case d-stack-none", "label" : "Qty", key: 'qtyCase', }, 
				{"uomName": {}, "class" : "th-uom-name d-stack-none", "label" : "UoM", key: 'uomName', }, 
				{"createdDate": {}, "class" : "th-created-date d-stack-none", "label" : "Transaction Date", key: 'createdDate', }, 
				{"qcStatusName": {}, "class" : "th-qc-status-name d-stack-none", "label" : "Status", key: 'qcStatusName', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportStockCards: [],
			reportStockCardsPaging: {},
			filterParts : [],
			filterRacks : [],
			filterCustomers : [],
			filterAreas : [],
			filterControlCards : [],
			filterUoms : [],
			filterQcStatuss : [],
			filterRef: [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
		}
	},	
	methods : {
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.filterRef.filterPart = null;
				this.filter.filterPart = null;
			} else {
				this.filterRef.filterPart = item.name;
				this.filter.filterPart = item.id;
			}
		},
		setSelectedRack(item) {
			if(item == undefined || item == null) {
				this.filterRef.filterRack = null;
				this.filter.filterRack = null;
			} else {
				this.filterRef.filterRack = item.name;
				this.filter.filterRack = item.id;
			}
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.filterRef.filterArea = null;
				this.filter.filterArea = null;
			} else {
				this.filterRef.filterArea = item.name;
				this.filter.filterArea = item.id;
			}
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.filterRef.filterControlCard = null;
				this.filter.filterControlCard = null;
			} else {
				this.filterRef.filterControlCard = item.name;
				this.filter.filterControlCard = item.id;
			}
		},
		setSelectedUom(item) {
			if(item == undefined || item == null) {
				this.filterRef.filterUom = null;
				this.filter.filterUom = null;
			} else {
				this.filterRef.filterUom = item.name;
				this.filter.filterUom = item.id;
			}
		},
		setSelectedQcStatus(item) {
			if(item == undefined || item == null) {
				this.filterRef.filterQcStatus = null;
				this.filter.filterQcStatus = null;
			} else {
				this.filterRef.filterQcStatus = item.name;
				this.filter.filterQcStatus = item.id;
			}
		},
		setSelectedCustomer(item) {
			if(item == undefined || item == null) {
				this.filterRef.filterCustomer = null;
				this.filter.filterCustomer = null;
			} else {
				this.filterRef.filterCustomer = item.name;
				this.filter.filterCustomer = item.id;
			}
		},
		getReportStockCards : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportStockCard.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportStockCards = result.data
					this.reportStockCardsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportStockCardsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportStockCard.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportStockCards = result.data
					this.reportStockCardsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterParts : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportStockCard.getListCustomUrl(this,'getlistfilterpart' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterParts = result.data
				}
			})
			.catch(error => {});
		},
		getFilterRacks : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportStockCard.getListCustomUrl(this,'getlistfilterrack' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterRacks = result.data
				}
			})
			.catch(error => {});
		},
		getFilterAreas : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportStockCard.getListCustomUrl(this,'getlistfilterarea' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterAreas = result.data
				}
			})
			.catch(error => {});
		},
		getFilterControlCards : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportStockCard.getListCustomUrl(this,'getlistfiltercontrolcard' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterControlCards = result.data
				}
			})
			.catch(error => {});
		},
		getFilterUoms : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportStockCard.getListCustomUrl(this,'getlistfilteruom' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterUoms = result.data
				}
			})
			.catch(error => {});
		},
		getFilterQcStatuss : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportStockCard.getListCustomUrl(this,'getlistfilterqcstatus' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterQcStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getFilterCustomers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportStockCard.getListCustomUrl(this,'getlistfiltercustomer' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterCustomers = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new ReportStockCardFilter();
			this.getReportStockCards();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportStockCards();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportStockCard.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportStockCard.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportStockCard.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportStockCard.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportStockCards();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportStockCard.deleteMultipleData(this).then(result => {
					this.getReportStockCards();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportStockCardParent = document.getElementById('table-list-reportstockcard').parentNode;
			tableReportStockCardParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportStockCardParent.scrollWidth - tableReportStockCardParent.offsetWidth) == Math.ceil(tableReportStockCardParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportStockCardParent = document.getElementById('table-list-reportstockcard').parentNode;
			tableReportStockCardParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportStockCardParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportStockCardFilter();
		this.getFilterParts()
		this.getFilterRacks()
		this.getFilterCustomers()
		this.getFilterAreas()
		this.getFilterControlCards()
		this.getFilterUoms()
		this.getFilterQcStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Stock Card"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportStockCards();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportStockCards();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportStockCards();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportStockCards();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportStockCards();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportStockCard.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportstockcardindex") {
					this.getReportStockCardsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_stock_card").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
